"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TwoCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TwoCircleLinear = function TwoCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.443 20.41c1.122-1.268 2.738-1.921 4.718-1.921 1.86 0 3.413.609 4.497 1.757 1.08 1.145 1.646 2.773 1.646 4.716 0 2.068-.639 3.714-2.022 5.133-.946.98-.98 1.006-4.486 3.799l-.05.04c-1.341 1.063-2.168 1.866-2.727 2.693-.526.78-.834 1.607-1.084 2.752l.539-.001h9.561a.5.5 0 01.5.5V41a.5.5 0 01-.5.5H24.023a.5.5 0 01-.5-.527c.119-2.187.45-3.76 1.522-5.34 1.048-1.547 2.784-3.067 5.6-5.223 1.337-1.077 2.171-1.923 2.677-2.758.496-.817.695-1.655.695-2.756 0-1.393-.394-2.476-1.051-3.204-.652-.723-1.607-1.147-2.838-1.147-1.326 0-2.314.453-2.997 1.279-.697.842-1.126 2.13-1.19 3.882a.5.5 0 01-.5.482h-1.22a.5.5 0 01-.5-.508c.034-2.205.608-4.01 1.722-5.27z",
    fill: "url(#TwoCircleLinear_svg__TwoCircleLinear_svg__paint0_linear_17373_95585)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#TwoCircleLinear_svg__TwoCircleLinear_svg__paint1_linear_17373_95585)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "TwoCircleLinear_svg__TwoCircleLinear_svg__paint0_linear_17373_95585",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "TwoCircleLinear_svg__TwoCircleLinear_svg__paint1_linear_17373_95585",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.TwoCircleLinear = TwoCircleLinear;
var _default = TwoCircleLinear;
exports.default = _default;